// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as DOMPurify$LiveRoom from "../../bindings/DOMPurify.bs.js";
import * as LoginModal$LiveRoom from "../../components/Modal/LoginModal.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as AnalyticsManager$LiveRoom from "../../analytics/AnalyticsManager.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as CollapsibleTextBlock$LiveRoom from "../../components/CollapsibleTextBlock.bs.js";

function LotContent$BlockTitle(props) {
  return React.createElement(SterlingTypography$LiveRoom.Label18Medium.make, {
              className: Curry._1(Css.style, {
                    hd: Css.important(Css.fontWeight({
                              NAME: "num",
                              VAL: 600
                            })),
                    tl: {
                      hd: Css.textTransform("capitalize"),
                      tl: {
                        hd: Css.marginTop(Css.px(16)),
                        tl: {
                          hd: Css.marginBottom(Css.px(8)),
                          tl: /* [] */0
                        }
                      }
                    }
                  }),
              children: props.title
            });
}

var BlockTitle = {
  make: LotContent$BlockTitle
};

function LotContent$DefaultContentBlock(props) {
  var onToggle = props.onToggle;
  var gated = props.gated;
  var blockInitiallyOpen = props.blockInitiallyOpen;
  var analyticsFn = props.analyticsFn;
  var contentText = props.contentText;
  var blockInitiallyOpen$1 = blockInitiallyOpen !== undefined ? blockInitiallyOpen : false;
  var gated$1 = gated !== undefined ? gated : false;
  var onToggle$1 = onToggle !== undefined ? onToggle : (function (param) {
        
      });
  if (contentText !== undefined && contentText !== "") {
    return React.createElement("div", {
                className: Curry._1(Css.style, {
                      hd: Css.marginTop(Css.px(16)),
                      tl: /* [] */0
                    })
              }, React.createElement(CollapsibleTextBlock$LiveRoom.make, {
                    title: props.contentTitle,
                    contentText: DOMPurify$LiveRoom.sanitize(contentText),
                    blockInitiallyOpen: blockInitiallyOpen$1,
                    onToggle: (function (toggle) {
                        if (toggle) {
                          Curry._1(analyticsFn, undefined);
                        }
                        Curry._1(onToggle$1, undefined);
                      }),
                    gated: gated$1
                  }));
  } else {
    return null;
  }
}

var DefaultContentBlock = {
  make: LotContent$DefaultContentBlock
};

function LotContent$LotDetailInfo(props) {
  var lotDetailText = props.lotDetailText;
  var match = I18next$LiveRoom.useTranslation(undefined);
  if (lotDetailText !== undefined) {
    return React.createElement(React.Fragment, undefined, React.createElement(LotContent$BlockTitle, {
                    title: Curry._1(match.t, "LotContent_Description")
                  }), React.createElement("div", {
                    className: Curry._1(Css.merge, {
                          hd: CommonStyles$LiveRoom.htmlContentStyle(16, 24),
                          tl: {
                            hd: Curry._1(Css.style, {
                                  hd: Css.whiteSpace("preWrap"),
                                  tl: {
                                    hd: Css.unsafe("word-break", "break-word"),
                                    tl: /* [] */0
                                  }
                                }),
                            tl: /* [] */0
                          }
                        }),
                    dangerouslySetInnerHTML: {
                      __html: DOMPurify$LiveRoom.sanitize(lotDetailText)
                    }
                  }));
  } else {
    return null;
  }
}

var LotDetailInfo = {
  make: LotContent$LotDetailInfo
};

function LotContent$ConditionReport(props) {
  var condition = props.condition;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = React.useState(function () {
        return /* NoModal */0;
      });
  var setModalToShow = match$1[1];
  var variant = condition.NAME;
  var conditionReportContent;
  if (variant === "ConditionPublished") {
    var match$2 = condition.VAL;
    var conditionReportDisclaimers = match$2.conditionReportDisclaimers;
    var report = match$2.report;
    var allConditionReportDisclaimers = Belt_Option.mapWithDefault(match$2.disclaimer, Belt_Array.keepMap(conditionReportDisclaimers, (function (c) {
                  return c.content;
                })), (function (disclaimer) {
              return Belt_Array.concat([disclaimer], Belt_Array.keepMap(conditionReportDisclaimers, (function (c) {
                                return c.content;
                              })));
            })).join("<br>");
    if (report !== undefined) {
      var exit = 0;
      if (report === "" && allConditionReportDisclaimers === "") {
        conditionReportContent = undefined;
      } else {
        exit = 1;
      }
      if (exit === 1) {
        conditionReportContent = allConditionReportDisclaimers === "" ? report : report + "<br>" + allConditionReportDisclaimers;
      }
      
    } else {
      conditionReportContent = allConditionReportDisclaimers === "" ? undefined : allConditionReportDisclaimers;
    }
  } else if (variant === "ConditionBehindLogin") {
    conditionReportContent = Curry._1(t, "Common_pleaseLogIn");
  } else if (variant === "ConditionHidden") {
    var contactEmail = condition.VAL.contactEmail;
    conditionReportContent = contactEmail !== undefined ? Curry._1(t, "LotContent_ConditionReportEmail") + ("<a href=\"mailto:" + contactEmail + "\"> " + contactEmail + " </a>") : undefined;
  } else {
    conditionReportContent = undefined;
  }
  return React.createElement(React.Fragment, undefined, React.createElement(LotContent$DefaultContentBlock, {
                  contentTitle: Curry._1(t, "LotContent_ConditionReport"),
                  contentText: conditionReportContent,
                  analyticsFn: props.analyticsFn,
                  gated: typeof condition === "object" ? condition.NAME === "ConditionBehindLogin" : false,
                  onToggle: (function (param) {
                      if (typeof condition === "object" && condition.NAME === "ConditionBehindLogin") {
                        return Curry._1(setModalToShow, (function (param) {
                                      return /* ConditionReportLoginModal */1;
                                    }));
                      }
                      
                    })
                }), match$1[0] ? React.createElement(LoginModal$LiveRoom.make, {
                    onClose: (function (param) {
                        Curry._1(setModalToShow, (function (param) {
                                return /* NoModal */0;
                              }));
                      }),
                    modalType: /* ConditionReportLogin */0
                  }) : null);
}

var ConditionReport = {
  make: LotContent$ConditionReport
};

function LotContent$Content(props) {
  var me = props.me;
  var lot = props.lot;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var disclaimers = Belt_Array.keepMap(lot.generalLotNotices, (function (disclaimer) {
          return disclaimer.content;
        }));
  return React.createElement(React.Fragment, undefined, React.createElement(LotContent$LotDetailInfo, {
                  lotDetailText: lot.description
                }), React.createElement(LotContent$ConditionReport, {
                  condition: lot.condition,
                  analyticsFn: (function (param) {
                      AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickConditionReport");
                    })
                }), React.createElement(LotContent$DefaultContentBlock, {
                  contentTitle: Curry._1(t, "Common_saleroomNotice"),
                  contentText: lot.saleroomNotice,
                  analyticsFn: (function (param) {
                      AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickSaleroomNotice");
                    }),
                  blockInitiallyOpen: true
                }), React.createElement(LotContent$DefaultContentBlock, {
                  contentTitle: Curry._1(t, "LotContent_Provenance"),
                  contentText: lot.provenance,
                  analyticsFn: (function (param) {
                      AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickProvenance");
                    }),
                  blockInitiallyOpen: true
                }), React.createElement(LotContent$DefaultContentBlock, {
                  contentTitle: Curry._1(t, "LotContent_Literature"),
                  contentText: lot.literature,
                  analyticsFn: (function (param) {
                      AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickLiterature");
                    }),
                  blockInitiallyOpen: true
                }), React.createElement(LotContent$DefaultContentBlock, {
                  contentTitle: Curry._1(t, "LotContent_Exhibited"),
                  contentText: lot.exhibition,
                  analyticsFn: (function (param) {
                      AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickExhibited");
                    }),
                  blockInitiallyOpen: true
                }), React.createElement(LotContent$DefaultContentBlock, {
                  contentTitle: Curry._1(t, "LotContent_CatalogueNote"),
                  contentText: lot.catalogueNote,
                  analyticsFn: (function (param) {
                      AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickCatalogueNote");
                    }),
                  blockInitiallyOpen: true
                }), React.createElement(LotContent$DefaultContentBlock, {
                  contentTitle: Curry._1(t, "LotContent_AdditionalNoticesAndDisclaimers"),
                  contentText: disclaimers.length !== 0 ? disclaimers.join("<br>") : undefined,
                  analyticsFn: (function (param) {
                      AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickDisclaimers");
                    }),
                  blockInitiallyOpen: false
                }));
}

var Content = {
  make: LotContent$Content
};

function LotContent$TabletAndMobileContent(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: React.createElement(SterlingModal$LiveRoom.Content.make, {
                    children: React.createElement(LotContent$Content, {
                          lot: props.lot,
                          me: props.me
                        })
                  }),
              className: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                          hd: Css.height(Css.pct(100)),
                          tl: {
                            hd: Css.important(Css.maxHeight(Css.pct(100))),
                            tl: {
                              hd: Css.important(Css.maxWidth(Css.pct(100))),
                              tl: /* [] */0
                            }
                          }
                        }),
                    tl: /* [] */0
                  }),
              onClose: props.closeLotDetails,
              isOpen: true,
              fixHeader: true,
              headerTitle: Curry._1(match.t, "Common_LotDetails")
            });
}

var TabletAndMobileContent = {
  make: LotContent$TabletAndMobileContent
};

function LotContent(props) {
  return React.createElement(LotContent$Content, {
              lot: props.lot,
              me: props.me
            });
}

var make = LotContent;

export {
  BlockTitle ,
  DefaultContentBlock ,
  LotDetailInfo ,
  ConditionReport ,
  Content ,
  TabletAndMobileContent ,
  make ,
}
/* Css Not a pure module */
